import { FC, Fragment, useState } from "react";
import ImgFull from "../atoms/ImgFull";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { t } from "i18next";

export type ProductProps = {
  product?: any;
  onAdd?: (product: any, amount: number) => void;
  isLoading?: boolean;
};

const MAX_DESCRIPTION_LENGTH = 55;

const Product: FC<ProductProps> = ({ product, onAdd, isLoading }) => {
  const [amount, setAmount] = useState(1);

  const truncatedDescription =
    product?.description && product?.description.length > MAX_DESCRIPTION_LENGTH
      ? product?.description.substring(0, MAX_DESCRIPTION_LENGTH) + "..."
      : product?.description;

  const handleAddProductToCar = () => {
    if (onAdd) {
      onAdd(product, amount);
      setAmount(1);
    }
  };

  return (
    <div>
      <div className="relative">
        {isLoading ? (
          <div className="relative h-72 w-full bg-gray-300 animate-pulse rounded-lg" />
        ) : (
          <div className="relative h-72 w-full overflow-hidden rounded-lg">
            <ImgFull src={product?.img} />
          </div>
        )}
        <div className="relative mt-4">
          {isLoading ? (
            <div className="w-full bg-gray-300 animate-pulse rounded-sm h-4" />
          ) : (
            <h3 className="text-sm font-medium text-gray-900">
              {product?.name}
            </h3>
          )}
          {isLoading ? (
            <Fragment>
              <div className="w-2/4 bg-gray-300 animate-pulse rounded-sm h-4 mt-1" />
            </Fragment>
          ) : (
            <p className="mt-1 text-sm text-gray-500 sm:truncate">
              {truncatedDescription}
            </p>
          )}
        </div>
        <div className="relative mt-4 mx-1">
          <div className="flex items-center justify-between">
            {isLoading ? (
              <div className="w-16 bg-gray-300 animate-pulse rounded-sm h-4" />
            ) : (
              <label
                htmlFor=""
                className="block text-sm font-medium leading-6 text-gray-600"
              >
                {t("store.views.form.amount")}
              </label>
            )}

            {isLoading ? (
              <div className="w-12 bg-gray-300 animate-pulse rounded-sm h-8" />
            ) : (
              <div className="w-12">
                <InputWithCornerHint
                  label=""
                  type="number"
                  max={product?.amount}
                  min={1}
                  value={amount}
                  onChange={(event) => setAmount(Number(event.target.value))}
                />
              </div>
            )}
          </div>
        </div>
        <div className="absolute inset-x-0 top-0 flex h-72 items-end justify-end overflow-hidden rounded-lg p-4">
          <div
            aria-hidden="true"
            className="absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-black opacity-50"
          />
          {isLoading ? (
            <div className="w-12 bg-gray-300 animate-pulse rounded-sm h-4" />
          ) : (
            <p className="relative text-lg font-semibold text-white">
              {`${product?.currency.toUpperCase()} ${parseFloat(
                product?.price
              ).toFixed(2)}`}
            </p>
          )}
        </div>
      </div>
      <div className="mt-6">
        {isLoading ? (
          <div className="w-full bg-gray-300 animate-pulse rounded-md h-8" />
        ) : (
          <button
            onClick={handleAddProductToCar}
            className="h-8 w-full relative flex items-center justify-center rounded-md border border-transparent bg-gray-100 px-8 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200"
          >
            {t("store.views.add_to_cart")}
          </button>
        )}
      </div>
    </div>
  );
};

export default Product;
